export default "__VITE_PUBLIC_ASSET__6c42633c__"